import {filterQuestions} from "../helpers/constants/filterQuestions";
import format from "date-fns/format";

export const calcCustomerDates = (customers = []) => {
  customers.forEach(customer => {
    let arrival = '-';
    let leave = '-';
    if (customer.reservations && customer.reservations.length > 0 ) {
      arrival = format(new Date(customer.reservations[0].startDate), 'dd/MM/yyyy');
      leave = format(new Date(customer.reservations[0].endDate), 'dd/MM/yyyy');
      customer.space = customer.reservations.map(res => res.space).join(' & ');
    }
    customer.arrival = arrival;
    customer.leave = leave;
  });
}

export const calculateCustomerStats = (customers) => {
  const stats = {
    numberOfCustomers:  0,
    numberOfProfiles: 0,
    count: {}
  }
  if (!customers || customers.length === 0) {
    return stats;
  }
  stats.numberOfCustomers = customers.length;
  const tags = ['room', 'food', 'beverage', 'music', 'logistics', 'marketing', 'activities', 'misc', 'feedback'];
  const filterTitles = filterQuestions;
  const filterTitlesLower = filterTitles.map(title => String(title).trim().toLowerCase());

  const isFilteredTitle = (title = '') => filterTitlesLower.indexOf(String(title).trim().toLowerCase()) !== -1;

  const normalizeValues = (values) => {
    if (Array.isArray(values)) {
      return values
        .filter(Boolean)
        .flatMap(value => String(value).split(';'))
        .map(value => value.trim())
        .filter(Boolean);
    }

    if (values === null || values === undefined) {
      return [];
    }

    return String(values)
      .split(';')
      .map(value => value.trim())
      .filter(Boolean);
  };

  const getTagEntries = (customer, tag) => {
    const properties = customer?.properties;
    const propertyPrefix = `${tag}--`;

    if (properties && typeof properties === 'object') {
      const propertyEntries = Object.entries(properties)
        .filter(([key]) => key.startsWith(propertyPrefix))
        .map(([, value]) => {
          if (!value || typeof value !== 'object') {
            return null;
          }

          return {
            title: value.label || '',
            values: normalizeValues(value.value),
          };
        })
        .filter(Boolean)
        .filter(entry => entry.title && entry.values.length > 0);

      if (propertyEntries.length) {
        return propertyEntries;
      }
    }

    const legacyTags = customer?.[`${tag}Tags`];
    if (!legacyTags || !legacyTags.length) {
      return [];
    }

    return legacyTags
      .map(tagValue => {
        if (!tagValue) {
          return null;
        }

        let title;
        let values;
        if (!tagValue.label) {
          const keyVal = String(tagValue).split(': ');
          title = keyVal[0];
          values = keyVal.slice(1).join(': ');
        } else {
          title = tagValue.label;
          values = tagValue.value || '';
        }

        return {
          title,
          values: normalizeValues(values),
        };
      })
      .filter(Boolean)
      .filter(entry => entry.title && entry.values.length > 0);
  };

  customers.forEach(customer => {
    tags.forEach(tag => {
      const tagEntries = getTagEntries(customer, tag);
      if (tagEntries.length) {
        tagEntries.forEach(({title, values}) => {
          if (isFilteredTitle(title)) {
            return;
          }

          stats.count[tag] = stats.count[tag] || {};
          stats.count[tag][title] = stats.count[tag][title] || {};

          values.forEach(value => {
            stats.count[tag][title][value] = stats.count[tag][title][value] || {
              count:0,
              label:value,
              selected: false,
              customers: []
            };
            stats.count[tag][title][value].count += 1;
            stats.count[tag][title][value].customers.push(customer);
          });
        });

        customer.hasProfile = true;
        if (tag === 'logistics') {
          customer.hasCS = tagEntries.some(entry => entry.title === 'Origin Destination');
        }
      }
    });
    if (customer.hasProfile) {
      stats.numberOfProfiles += 1;
    }
  });
  Object.keys(stats.count).forEach(tag => {
    Object.keys(stats.count[tag]).forEach(key => {
      stats.count[tag][key] = Object.values(stats.count[tag][key]).sort((a, b) => (b.count - a.count));
    });
  });
  return stats;
}
